<template>
  <div class="app flex-row align-items-center">
    <div class="container">
      <b-row class="justify-content-center">
        <b-col md="6">
          <b-card class="mb-2">
            <div v-if="sent">
              <div class="h4 mb-4">Check your email</div>
              <p class="text-muted">
                A verification code has been sent to your email.
              </p>
            </div>
            <div v-else>
              <b-form class="px-4">
                <div class="h4 mb-4">Reset your password</div>
                <p class="alert alert-warning" v-if="error_msg">
                  {{ error_msg }}
                </p>

                <b-input-group class="mb-3">
                  <b-input-group-prepend><b-input-group-text><i class="icon-user"></i></b-input-group-text></b-input-group-prepend>
                  <b-form-input type="text" class="form-control" placeholder="Your email" autocomplete="username-email" v-model="username" />
                </b-input-group>

                <b-row>
                  <b-col>
                    <b-button variant="primary" block class="text-uppercase font-weight-bold py-2" @click="sendReset">Send</b-button>
                  </b-col>
                </b-row>
              </b-form>
            </div>
          </b-card>
          <b-row>
            <b-col>
              <b-button variant="link" block class="px-0 pt-3 text-center" to="/login">Back to login</b-button>
            </b-col>
          </b-row>
        </b-col>
      </b-row>
    </div>
  </div>
</template>

<script>
import {
  AUTH_PASSWORD_RESET_REQUEST
} from "@/store/action-types";

export default {
  name: "PasswordReset",
  data() {
    return {
      username: this.$store.getters.getAuthenticatedUsername || null,
      sent: false,
      error_msg: null
    };
  },
  methods: {
    sendReset() {
      console.log(this.username);
      this.$store
        .dispatch(AUTH_PASSWORD_RESET_REQUEST, { username: this.username })
        .then(data => {
          this.sent = true;
        })
        .catch(err => {
          const error = this.$store.getters.getAuthenticationError;
          if (error) {
            this.error_msg = error;
          } else {
            this.error_msg =
              "Something went wrong please contact an administrator";
          }
        });
    }
  }
  /*async beforeCreate() {
    this.$store.dispatch(AUTH_CHECK_LOGIN, {}).then(data => {
      this.$router.push('/dashboard');
    }).catch((e) => {
      //:: TODO handle check
    });
  }*/
};
</script>
